export class Navigation {

    public static HOME_VIEW: number = 1;
    public static PROFILE_VIEW: number = 2;
    public static EXIT: number = 3;
    public static QUESTIONNAIRE_VIEW: number = 4;
}
